import { useContext, useEffect, useState } from "react";
import { StyledInProgressAttendances } from "./style";
import { TableItem } from "./TableItem";
import api from "../../../../services/api";
import { FinishedAttendanceDetails } from "../../../../interfaces/Attendances.interfaces";
import Input from "../../../../components/Input";
import MultiSelect from "../../../../components/MultiSelect";
import { defaultInput100, defaultSelect100 } from "../../../../components-variants/defaultInputs";
import { currentRoute, LoginContext } from "../../../../contexts/global/LoginContext";
import { set } from "react-hook-form";

export const FinishedAttendances = () => {
    const [attendances, setAttendances] = useState<Array<FinishedAttendanceDetails>>([]);
    const operators = Array.from(new Set(attendances.map(a => a.OPERADOR)));
    const types = Array.from(new Set(attendances.map(a => a.TIPO)));

    const { user } = useContext(LoginContext);

    const [filterOperator, setFilterOperator] = useState<string[]>([]);
    const [filterId, setFilterId] = useState<string>("");
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [limit, setLimit] = useState(50);
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({
        operator: [],
        type: [],
        id: '',
        contact: '',
        customer: '',
        number: ''
    });
    const [operatorsOptions, setOperatorsOptions] = useState<{ name: string; value: string, key: string }[]>([]);
    const [typesOptions, setTypesOptions] = useState<{ name: string; value: string, key: string }[]>([]);

    useEffect(() => {
        let url = `/custom-routes/finished-attendances?page=${page}&limit=${limit}`;

        if (filters.operator.length) url += `&operator=${filters.operator.join(',')}`;
        if (filters.type.length) url += `&type=${filters.type.join(',')}`;
        if (filters.id) url += `&id=${filters.id}`;
        if (filters.contact) url += `&contact=${filters.contact}`;
        if (filters.customer) url += `&customer=${filters.customer}`;
        if (filters.number) url += `&number=${filters.number}`;

        api.get<{
            data: FinishedAttendanceDetails[];
            total: number;
            page: number;
            limit: number;
            totalPages: number;
        }>(url)
            .then((res) => {
                let attendancesData = res.data.data;

                if (currentRoute === "vollo" && user && user.SETOR === 15) {
                    attendancesData = attendancesData.filter(a => a.CODIGO_SETOR === 15);
                }

                attendancesData.forEach(a => {
                    a.DATA_INICIO = new Date(a.DATA_INICIO);
                    a.DATA_FIM = new Date(a.DATA_FIM!);
                });

                setAttendances(attendancesData);
                setTotalPages(res.data.totalPages);

            });
    }, [page, limit, filters]);
    useEffect(() => {
        api.get<Array<FinishedAttendanceDetails>>(`/custom-routes/operators-and-types`)
            .then((res) => {
                const operators = Array.from(new Set(res.data.map(a => a.OPERADOR)));
                const types = Array.from(new Set(res.data.map(a => a.TIPO)));
                setOperatorsOptions(operators.map(op => ({ name: op, value: op, key: op })));
                setTypesOptions(types.map(tp => ({ name: tp, value: tp, key: tp })));
                setAttendances(res.data)
            });
    }, []);
    const handleFilterChange = (name: string, value: any) => {
        setPage(1);
        setFilters(prev => ({
            ...prev,
            [name]: value
        }));
    };

    return (
        <StyledInProgressAttendances>
            <header>
                <div className="actionsh">
                    Ações
                </div>
                <div className="codah search">
                    <Input
                        placeholder="ID"
                        value={filters.id}
                        onChange={(e) => {
                            setFilterId(e.target.value)
                            handleFilterChange('id', e.target.value)
                        }
                        }
                        {...defaultInput100}
                        $disableBorder
                        $fontSize={0.75}
                    />
                </div>
                <div className="operatorh search">
                    <MultiSelect
                        options={operatorsOptions}
                        onChange={(v) => handleFilterChange('operator', v)}
                        placeholder="Operador"
                        $disableBorder
                        {...defaultSelect100}
                        $fontSize={0.75}
                    />
                </div>
                <div className="clientnameh search">
                    <Input
                        placeholder="Contato"
                        value={filters.contact}
                        onChange={(e) => handleFilterChange('contact', e.target.value.toUpperCase())}
                        {...defaultInput100}
                        $disableBorder
                        $fontSize={0.75}
                    />
                </div>
                <div className="numberh search">
                    <Input
                        placeholder="Numero"
                        value={filters.number}
                        onChange={(e) => handleFilterChange('number', e.target.value.replace(/\D/g, ""),)}
                        {...defaultInput100}
                        $disableBorder
                        $fontSize={0.75}
                    />
                </div>
                <div className="clientcompanyh search">
                    <Input
                        placeholder="Razão Social"
                        value={filters.customer}
                        onChange={(e) => handleFilterChange('customer', e.target.value.toUpperCase())}
                        {...defaultInput100}
                        $disableBorder
                        $fontSize={0.75}
                    />
                </div>
                <div className="startdateh">
                    Iniciado
                </div>
                <div className="enddateh">
                    Finalizado
                </div>
                <div className="atypeh search">
                    <MultiSelect
                        options={typesOptions}
                        onChange={(v) => handleFilterChange('tipo', v)}
                        placeholder="Tipo"
                        $disableBorder
                        {...defaultSelect100}
                        $fontSize={0.75}
                    />
                </div>
            </header>
            <div>
                {
                    attendances.map((attendance, index) => <TableItem attendance={attendance} key={index} />)
                }
            </div>
            <div className="pagination-controls">
                <div className="pagination-buttons">
                    <button
                        className="pagination-button"
                        onClick={() => setPage(p => Math.max(1, p - 1))}
                        disabled={page === 1 || loading}
                    >
                        &lt;
                    </button>

                    <span className="page-indicator">
                        Página {page} de {totalPages}
                    </span>

                    <button
                        className="pagination-button"
                        onClick={() => setPage(p => Math.min(totalPages, p + 1))}
                        disabled={page === totalPages || loading}
                    >
                        &gt;
                    </button>
                </div>

                <div className="page-size-selector">
                    <select
                        value={limit}
                        onChange={(e) => setLimit(Number(e.target.value))}
                        disabled={loading}
                    >
                        {[10, 25, 50, 100].map(opt => (
                            <option key={opt} value={opt}>{opt} itens</option>
                        ))}
                    </select>
                </div>
            </div>
        </StyledInProgressAttendances>
    );
};